package fyi.moko.hotpl.data.service

data class FirebaseEmulatorConfig(
    val host: String? = null
)
